import { useOffline } from "@/contexts/OfflineContext";
import { motion, AnimatePresence } from "framer-motion";
import { Wifi, WifiOff } from "lucide-react";

export default function OfflineBanner() {
  const ctx = useOffline();
  if (!ctx) return null;
  const { isOffline, showBackOnline } = ctx;

  return (
    <AnimatePresence>
      {isOffline && (
        <motion.div
          key="offline"
          initial={{ y: -40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -40, opacity: 0 }}
          className="fixed top-0 left-0 right-0 z-[9998] bg-slate-800 text-white text-center py-2 text-[12px] font-medium flex items-center justify-center gap-2"
          data-testid="offline-banner"
        >
          <WifiOff className="w-3.5 h-3.5" />
          You're offline — we'll sync when you're back
        </motion.div>
      )}
      {showBackOnline && !isOffline && (
        <motion.div
          key="back-online"
          initial={{ y: -40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -40, opacity: 0 }}
          className="fixed top-0 left-0 right-0 z-[9998] bg-emerald-500 text-white text-center py-2 text-[12px] font-medium flex items-center justify-center gap-2"
          data-testid="online-banner"
        >
          <Wifi className="w-3.5 h-3.5" />
          You're back online
        </motion.div>
      )}
    </AnimatePresence>
  );
}
